// Mock data for NPSH Developers website

export const mockProjects = [
  {
    id: 7,
    title: "NIVASAM",
    type: "Residential",
    location: "Arumbakkam, Chennai",
    status: "Under Construction",
    image: "pics/nivasam/nivasam1.webp",
    images: [
      "pics/nivasam/nivasam1.webp",
      "pics/nivasam/nivasam2.webp",
      "pics/nivasam/nivasam3.webp",
      "pics/nivasam/nivasam4.jpeg",
      "pics/nivasam/nivasam5.jpeg",
      "pics/nivasam/nivasam6.jpeg",
      "pics/nivasam/nivasam7.jpeg",
      "pics/nivasam/nivasam8.jpeg",
      "pics/nivasam/nivasam9.jpeg",
      "pics/nivasam/nivasam10.jpeg"
    ],
    bhk: "2 BHK & 3 BHK",
    area: "1038 – 2080 sq.ft (16 Dwelling units)",
    features: [
      "Stilt-Level Car Parking",
      "Automatic Lift System",
      "Full Power Backup with Auto Changeover",
      "UPS Provision",
      "Generator Backup",
      "EV Charging Point",
      "Red Brick Construction",
      "CCTV in Common Areas",
      "Video Door calling",
      "Unisex Gym"
    ],
    description: "Nivasam is an exclusive gated community of 16 premium 2 & 3 BHK residences designed to deliver elegant urban living with spacious layouts, high-end fittings, and refined finishes. Located in the heart of Arumbakkam, it offers quick access to top schools, hospitals, theatres, and temples — blending comfort, security, and convenience."
  },
  {
    id: 6,
    title: "NARAIN",
    type: "Residential",
    location: "KK Nager, Chennai",
    status: "Under Construction",
    image: "pics/narain/narain1.webp",
    images: [
      "pics/narain/narain1.webp",
      "pics/narain/narain2.jpg",
      "pics/narain/narain3.jpg"
    ],
    bhk: "3 BHK",
    area: "1271 sq.ft (4 units)",
    features: [
      "Dedicated car parking at stilt level",
      "Automatic Lift System",
      "UPS Provision for All Flats",
      "Entrance Door Camera View",
      "RCC Structure (Stilt + 3 Floors)",
      "Borewell with RCC Sump & OHT",
      "Rainwater Harvesting",
      "Generator Backup",
      "High-quality CP & sanitary fixtures",
      "CCTV in Common Areas"
    ],
    description: "Narain is a compact premium residential project offering six thoughtfully designed 2 BHK flats across three floors. It reflects a perfect balance of quality construction, practical space planning, and essential urban conveniences in the prime location of Villivakkam, Chennai."
  },
  {
    id: 8,
    title: "NITHYAM",
    type: "Residential",
    location: "Natesan Nager, Chennai",
    status: "Under Construction",
    image: "pics/nithyam/nithyam1.webp",
    images: [
      "pics/nithyam/nithyam1.webp",
      "pics/nithyam/nithyam2.jpeg",
      "pics/nithyam/nithyam3.jpeg",
      "pics/nithyam/nithyam4.jpeg",
      "pics/nithyam/nithyam5.jpeg",
      "pics/nithyam/nithyam6.jpeg",
      "pics/nithyam/nithyam7.jpeg",
    ],
    bhk: "3 BHK",
    area: "1800 sq.ft (6 units)",
    features: [
      "Dedicated car parking at stilt level",
      "Biometric Access",
      "Automatic Lift System",
      "UPS Provision for All Flats",
      "Entrance Door Camera View",
      "RCC Structure (Stilt + 3 Floors)",
      "Borewell with RCC Sump & OHT",
      "Rainwater Harvesting",
      "High-quality CP & sanitary fixtures",
      "CCTV in Common Areas"
    ],
    description: "Nithyam is a compact premium residential project offering six thoughtfully designed 2 BHK flats across three floors. It reflects a perfect balance of quality construction, practical space planning, and essential urban conveniences in the prime location of Villivakkam, Chennai."
  },
  {
    id: 1,
    title: "NATPA",
    type: "Residential",
    location: "Padi, Chennai",
    status: "Sold Out",
    image: "pics/natpa/natpa1.webp",
    images: [
      "pics/natpa/natpa1.webp",
      "pics/natpa/natpa2.webp",
      "pics/natpa/natpa3.webp"
    ],
    bhk: "1 ground land area (5 Units)",
    area: "2500-3500 sq.ft",
    features: [
      "Paid Car Parking",
      "Automatic Lift System",
      "UPS Provision for Flats",
      "Independent Bore Well",
      "RCC UG Sump & OHT",
      "CCTV in Common Areas",
      "Entrance Door Camera View"
    ],
    description: "A compact and well-executed residential project designed for urban families. NATPA blends efficiency and elegance in a premium location, successfully handed over in 2020 to satisfied homeowners."
  },
  {
    id: 2,
    title: "NAVITA",
    type: "Residential",
    location: "Sastha Nagar, Chennai",
    status: "Sold Out",
    image: "pics/navita/navita1.webp",
    images: [
      "pics/navita/navita1.webp",
      "pics/navita/navita2.webp",
      "pics/navita/navita3.webp",
      "pics/navita/navita4.jpg",
      "pics/navita/navita5.jpg",
      "pics/navita/navita6.jpg"
    ],
    bhk: "2 and 3 BHK",
    area: "Spread over 2 grounds (8 total units)",
    features: [
      "Dedicated Stilt-Level Car Parking",
      "Automatic Lift System",
      "Biometric Access",
      "UPS Provision for Each Flat",
      "Independent Bore Well",
      "RCC Underground Sump & Overhead Tank",
      "Video Door Phone with Security Locks",
      "CCTV Surveillance in Common Areas"
    ],
    description: "Experience refined living at NAVITA — thoughtfully crafted 2 BHK residences with modern amenities, nestled in a well-connected neighborhood of Chennai."
  },
  {
    id: 3,
    title: "NANDIKA",
    type: "Residential",
    location: "Virugambakkam, Chennai",
    status: "Sold Out",
    image: "pics/nandika/nandika1.webp",
    images: [
      "pics/nandika/nandika1.webp",
      "pics/nandika/nandika2.webp",
      "pics/nandika/nandika3.webp",
      "pics/nandika/nandika4.jpeg",
      "pics/nandika/nandika5.jpeg",
      "pics/nandika/nandika6.jpeg",
      "pics/nandika/nandika7.jpeg",
      "pics/nandika/nandika8.jpeg",
      "pics/nandika/nandika9.jpeg",
      "pics/nandika/nandika10.jpeg"
    ],
    bhk: "3 BHK",
    area: "1255–1383 sq.ft",
    price: "-",
    features: [
      "Stilt floor car parking",
      "Multiple balconies",
      "Family/dining room",
      "Spacious master bedroom"
    ],
    description: "A premium 5-floor residential project offering 10 spacious 3 BHK units. Designed for comfort and located in a well-connected neighborhood with modern structural planning and elegant elevation."
  },
  {
    id: 4,
    title: "NAKSHATRA",
    type: "Residential",
    location: "Sastha Nagar, Chennai",
    status: "Sold Out",
    image: "pics/nakshatra/nakshatra1.webp",
    images: [
      "pics/nakshatra/nakshatra1.webp",
      "pics/nakshatra/nakshatra2.webp",
      "pics/nakshatra/nakshatra3.webp"
    ],
    bhk: "2 BHK",
    area: "1 ground land area (6 units)",
    features: [
      "Paid Stilt-Level Car Parking",
      "Automatic Lift System",
      "Video Door Phone with Security Locks",
      "UPS Provision for All Flats",
      "Entrance Door Camera View",
      "RCC Structure (Stilt + 3 Floors)",
      "Borewell with RCC Sump & OHT",
      "Rainwater Harvesting",
      "3-Phase TNEB Power Supply",
      "CCTV in Common Areas"
    ],
    description: "NAKSHATRA is a thoughtfully designed residential enclave in Villivakkam offering 6 spacious 2 BHK units. It combines modern construction quality with functional layouts, energy-efficient systems, and a host of lifestyle amenities — delivering secure and comfortable living in a prime Chennai location."
  },
  {
    id: 5,
    title: "NARMAD",
    type: "Residential",
    location: "Sastha Nagar, Chennai",
    status: "Available",
    image: "pics/narmad/narmad1.webp",
    images: [
      "pics/narmad/narmad1.webp",
      "pics/narmad/narmad2.webp",
      "pics/narmad/narmad3.webp",
      "pics/narmad/narmad4.jpeg",
      "pics/narmad/narmad5.jpeg",
      "pics/narmad/narmad6.jpeg",
      "pics/narmad/narmad7.jpeg",
    ],
    bhk: "2 BHK",
    area: "2600 sq.ft (6 units)",
    features: [
      "Dedicated car parking at stilt level",
      "Automatic Lift System",
      "UPS Provision for All Flats",
      "Entrance Door Camera View",
      "RCC Structure (Stilt + 3 Floors)",
      "Borewell with RCC Sump & OHT",
      "Rainwater Harvesting",
      "High-quality CP & sanitary fixtures",
      "CCTV in Common Areas"
    ],
    description: "Narmad is a compact premium residential project offering six thoughtfully designed 2 BHK flats across three floors. It reflects a perfect balance of quality construction, practical space planning, and essential urban conveniences in the prime location of Villivakkam, Chennai."
  },
  ,
  
];

export const mockServices = [
  {
    id: 1,
    title: "Residential Construction",
    description: "Premium residential projects with modern amenities and quality construction.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Commercial Development",
    description: "State-of-the-art commercial spaces designed for modern business needs.",
    icon: "Building"
  },
  {
    id: 3,
    title: "Interior Design",
    description: "Complete interior solutions with contemporary designs and premium materials.",
    icon: "Palette"
  },
  {
    id: 4,
    title: "Project Planning",
    description: "Comprehensive project planning and management for timely delivery.",
    icon: "ClipboardList"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Imran Zyn",
    rating: 5,
    comment: "The construction quality of the property is excellent, with the use of well-finished wire-cut bricks that enhance both durability and aesthetics. The craftsmanship is evident in the smooth and uniform finish, ensuring a sturdy and visually appealing structure. Additionally, the customer service is commendable, with a professional and responsive team that addresses queries efficiently. Their commitment to quality and customer satisfaction makes the overall experience smooth and reliable…Highly recommended",
    image: "pics/team/icon.webp"
  },
  {
    id: 2,
    name: "siva kumar",
    rating: 5,
    comment: "Great work done by the sales team! They assisted us completely right from the start which made us very comfortable. Thank you,",
    image: "pics/team/icon.webp"
  },
  {
    id: 3,
    name: "krishna prasad",
    rating: 5,
    comment: "Best price with good quality construction, good staff, within budget price. Thank you NPSH.",
    image: "pics/team/icon.webp"
  },
  {
    id: 4,
    name: "Murugan Monisha",
    rating: 5,
    comment: "Their response was superfast and speedy. Coordination with client and team is good.",
    image: "pics/team/icon.webp"
  }
];

export const mockGallery = [
  {
    id: 1,
    title: "Nakshatra",
    image: "pics/gallery/nakshatra1.jpg"
  },
  {
    id: 2,
    title: "Nandika",
    image: "pics/gallery/nandika1.jpg"
  },
  {
    id: 3,
    title: "Narain",
    image: "pics/gallery/narain1.jpg"
  },
  {
    id: 4,
    title: "Narmada",
    image: "pics/gallery/narmad1.webp"
  }
];

export const companyStats = [
  { label: "Projects Completed", value: "10+", icon: "Building" },
  { label: "Years of Experience", value: "12+", icon: "Clock" },
  { label: "Happy Families", value: "100+", icon: "Users" },
  { label: "Square Feet Built", value: "5M+", icon: "Square" }
];